import React from "react";
import { connect } from "react-redux";
import style from "./MsaClickCharges.module.css";
import { Table } from "react-bootstrap";

function MsaClickCharges({
  msaMetroClickChargeBw,
  msaMetroClickChargeColour,
  msaRegionalClickChargeBw,
  msaRegionalClickChargeColour
}) {
  return (
    <Table variant="sm" className={style.root}>
      <thead>
        <tr>
          <th className={style.colHead} />
          <th className={style.colMinPrice}>Metro</th>
          <th className={style.colTargetPrice}>Regional</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Black &amp; White</th>
          <td>{msaMetroClickChargeBw ? `${msaMetroClickChargeBw}¢` : "N/A"}</td>
          <td>
            {msaRegionalClickChargeBw ? `${msaRegionalClickChargeBw}¢` : "N/A"}
          </td>
        </tr>

        <tr>
          <th>Colour</th>
          <td>
            {msaMetroClickChargeColour
              ? `${msaMetroClickChargeColour}¢`
              : "N/A"}
          </td>
          <td>
            {msaRegionalClickChargeColour
              ? `${msaRegionalClickChargeColour}¢`
              : "N/A"}
          </td>
        </tr>
      </tbody>
    </Table>
  );
}

export default connect(state => {
  const {
    msaMetroClickChargeBw,
    msaMetroClickChargeColour,
    msaRegionalClickChargeBw,
    msaRegionalClickChargeColour
  } = state.product;

  return {
    msaMetroClickChargeBw,
    msaMetroClickChargeColour,
    msaRegionalClickChargeBw,
    msaRegionalClickChargeColour
  };
})(MsaClickCharges);
